export default __webpack_public_path__ + "static/N0259-67280734c6a7ee7e9f014d5a8fa1f9c0.png";